// Mesmo contrato de pontonow_backend/src/utils/geofence.js: maior que zero e até 200000 m.
export const MAX_RADIUS_METERS = 200000;

export const radiusErrorMessage = 'Informe um raio maior que zero e de até 200000 metros.';

export const parsePresenceRadius = (raw) => {
  if (raw == null || (typeof raw === 'string' && raw.trim() === '')) {
    return { ok: false, empty: true };
  }
  const value = typeof raw === 'number' ? raw : Number(String(raw).trim().replace(',', '.'));
  if (!Number.isFinite(value) || value <= 0 || value > MAX_RADIUS_METERS) {
    return { ok: false, invalid: true };
  }
  return { ok: true, value };
};

export const sliderPosition = (meters) => {
  const parsed = parsePresenceRadius(meters);
  const value = Math.min(MAX_RADIUS_METERS, Math.max(1, parsed.ok ? parsed.value : 1));
  return Math.round((Math.log(value) / Math.log(MAX_RADIUS_METERS)) * 1000);
};

export const metersFromSlider = (position) => {
  const ratio = Math.min(1000, Math.max(0, Number(position))) / 1000;
  const meters = Math.round(Math.exp(ratio * Math.log(MAX_RADIUS_METERS)));
  return Math.min(MAX_RADIUS_METERS, Math.max(1, meters));
};
